import { toKana } from 'wanakana';

const PUNCTUATION_REGEX = /[、。！？…「」『』【】〔〕（）：；，．,.!?;:'"()[\]{}~〜]/g;
export const stripPunctuation = (str) => str.replace(PUNCTUATION_REGEX, '');

const KANA_ONLY_REGEX = /^[\u3040-\u309F\u30A0-\u30FF]+$/;
export const isKanaOnly = (str) => !!str && KANA_ONLY_REGEX.test(str);

export const handleKanaInputChange = (setInputFunction, inputRef) => {
  return (e) => {
    let input = e.target.value;

    // Store the initial cursor position
    const cursorPosition = e.target.selectionStart;

    let pendingConversion = false;
    for (let i = 0; i < input.length; i++) {
      if (input[i] === 'n') {
        const nextChar = input[i + 1];
        if (nextChar === 'n') {
          i += 1;
          pendingConversion = false;
          continue;
        }
        if (nextChar === undefined || !/^[a-zA-Z]$/.test(nextChar)) {
          pendingConversion = true;
          break;
        } else if (nextChar === 'y') {
          const followingChar = input[i + 2];
          if (!"auo".includes(followingChar)) {
            pendingConversion = true;
            break;
          }
        }
      }
    }

    if (!pendingConversion) {
      // Convert input to kana
      const kanaInput = toKana(input, {
        IMEMode: true,
        passRomaji: true,
        upcaseKatakana: true,
        useObsoleteKana: false,
      });

      // Calculate new cursor position based on kana transformation
      const newCursorPosition = cursorPosition + (kanaInput.length - input.length);

      // Update the input and restore cursor position
      setInputFunction(kanaInput);
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setSelectionRange(newCursorPosition, newCursorPosition);
        }
      }, 0);
    } else {
      // If conversion is pending, keep input as-is
      setInputFunction(input);
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
      }, 0);
    }
  };
};